import { render, staticRenderFns } from "./supplier-edit.vue?vue&type=template&id=118da0c8"
import script from "./supplier-edit.vue?vue&type=script&lang=js"
export * from "./supplier-edit.vue?vue&type=script&lang=js"
import style0 from "./supplier-edit.vue?vue&type=style&index=0&id=118da0c8&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118da0c8')) {
      api.createRecord('118da0c8', component.options)
    } else {
      api.reload('118da0c8', component.options)
    }
    module.hot.accept("./supplier-edit.vue?vue&type=template&id=118da0c8", function () {
      api.rerender('118da0c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier-edit.vue"
export default component.exports